import React, { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { apiErr } from "./util";

const GROUPS = ["Teaching", "School", "SSC", "Banking", "Railways", "Defence", "Police", "Civil Services", "Entrance", "Other"];

function ExamRow({ e, reload }) {
  const [subjects, setSubjects] = useState((e.subjects || []).join(", "));
  const save = (body) => api.put(`/testseries/admin/exams/${e.id}`, body).then(() => { toast.success("Saved"); reload(); }).catch(apiErr);
  return (
    <div className="grid md:grid-cols-[200px_1fr_auto_auto] gap-3 items-center border-t border-border py-3" data-testid={`ats-exam-${e.slug}`}>
      <div><div className="font-semibold text-navy text-sm">{e.name}</div><div className="text-xs text-muted-foreground">{e.group}</div></div>
      <Input value={subjects} onChange={(x) => setSubjects(x.target.value)} onBlur={() => subjects !== (e.subjects || []).join(", ") && save({ subjects: subjects.split(",").map((x) => x.trim()).filter(Boolean) })} data-testid={`ats-exam-subjects-${e.slug}`} />
      <label className="flex items-center gap-2 text-xs"><Switch checked={e.active} onCheckedChange={(v) => save({ active: v })} data-testid={`ats-exam-active-${e.slug}`} />Visible</label>
      <Button size="icon" variant="ghost" onClick={() => window.confirm(`Delete ${e.name}?`) && api.delete(`/testseries/admin/exams/${e.id}`).then(reload).catch(apiErr)} data-testid={`ats-exam-del-${e.slug}`}><Trash2 size={15} /></Button>
    </div>
  );
}

export function ExamsTab({ exams, reload }) {
  const [f, setF] = useState({ name: "", group: "Teaching", subjects: "" });
  const add = () => api.post("/testseries/admin/exams", { ...f, subjects: f.subjects.split(",").map((x) => x.trim()).filter(Boolean) })
    .then(() => { toast.success("Exam added"); setF({ ...f, name: "", subjects: "" }); reload(); }).catch(apiErr);
  return (
    <div className="space-y-5">
      <div className="bg-white border border-border rounded-xl p-5 grid md:grid-cols-[1fr_160px_1.5fr_auto] gap-3" data-testid="ats-exam-form">
        <Input placeholder="Exam name (e.g. Bihar STET)" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="ats-exam-name" />
        <select className="h-10 border border-border rounded-md px-2 text-sm" value={f.group} onChange={(e) => setF({ ...f, group: e.target.value })} data-testid="ats-exam-group">{GROUPS.map((g) => <option key={g}>{g}</option>)}</select>
        <Input placeholder="Subjects, comma separated" value={f.subjects} onChange={(e) => setF({ ...f, subjects: e.target.value })} data-testid="ats-exam-subjects" />
        <Button className="viriks-amber text-white" onClick={add} data-testid="ats-exam-add">Add exam</Button>
      </div>
      <div className="bg-white border border-border rounded-xl px-5">{exams.map((e) => <ExamRow key={e.id} e={e} reload={reload} />)}</div>
    </div>
  );
}
